// Matches provinces from JB (keys, abbreviations) to Shopify (full text)
export const PROVINCEMAP = {
  NSW: 'New South Wales',
  VIC: 'Victoria',
  QLD: 'Queensland',
  TAS: 'Tasmania',
  SA: 'South Australia',
  WA: 'Western Australia',
  NT: 'Northern Territory',
  ACT: 'Australian Capital Territory',
  OT: 'New South Wales', // From Neil: OT  = "Other Territories" like Norfolk Island, which comes up half in NSW, half in OT
};

/**
 * Converts long province to short
 *
 * @param {*} long
 */
export function provinceToShort(long) {
  let short;
  Object.keys(PROVINCEMAP).forEach(key => {
    if (PROVINCEMAP[key] === long) {
      short = key;
    }
  });
  return short;
}

/**
 * Converts short province to long
 *
 * @param {*} short
 */
export function provinceToLong(short) {
  return PROVINCEMAP[short];
}

/**
 * Formats address object into a single line
 *
 * @param {*} props
 */
export function formatAddress(props) {
  const business_name = props.business_name ? `${props.business_name}, ` : '';
  const address = props.address ? `${props.address}, ` : '';
  const address2 = props.address2 ? `${props.address2}, ` : '';
  const qas_address = props.qas_address ? `${props.qas_address}` : '';
  const short = provinceToLong(props.state) ? props.state : provinceToShort(props.state);
  const state = short ? `${short} ` : '';
  return `${business_name}${address}${address2}${qas_address} ${props.city} ${state}${props.postcode}`;
}
